import React, { useEffect, useState } from 'react';
import WelcomepageDesign from "../../image/Welcomepage-Design.svg";
import BlueColorLogo from "../../image/BlueColorLogo.svg";
import { Link } from 'react-router-dom';
import { Button, Dialog, DialogContent, DialogContentText } from '@mui/material';
import "./Welcome.css";




const Welcome = (props) => {

  const [formrendering, setformrendering] = useState({});
  
useEffect(()=>
{
  
  const formrender = async (formid) => {


    const response = await fetch(`http://localhost:3001/form/${process.env.REACT_APP_ONBOARDINGFORM_FORMID}`, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        //   'Content-Type': 'application/json',

        "x-jwt-token": process.env.REACT_APP_X_JWT_TOKEN,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      // body: JSON.stringify(data) // body data type must match "Content-Type" header
    })

    let data = await response.json();
  
    localStorage.setItem("formArray", JSON.stringify(data));
    const waiting=await setformrendering(data);

      
  };

  formrender();


},[])




  function logout() 
  {

    props.state.keycloak.logout();
  
  }



  return (
    <div>
   
        <div className='navbar nav WelcomeNavbar'>
          <div >
          <span><img src={BlueColorLogo} className="LogoWith-green-Color"/></span>
            <span className='WelcomePage-Date'>{new Date().toLocaleDateString('en-US', { 
  weekday: 'long', 
  day: 'numeric', 
  month: 'short', 
  year: 'numeric' 
})}</span>
          </div>
          <div><span className='accountHolder'> <Button
            className="AccountHolder Settings btn"
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {(JSON.parse(localStorage.getItem("UserDetails")).preferred_username).slice(0,1)}
          </Button>
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <span className="dropdown-item">user</span>
            <hr />
            <span onClick={logout} className="dropdown-item">
              Logout
            </span>
          </div></span></div>
        </div>
        <div className='WelcomePage'>
            <div className='Welcomepage-Lefthandside'>
            <div className='First-Phase'>
                <h6 className='Welcome-Title'>Welcome Aboard, {(JSON.parse(localStorage.getItem("UserDetails")).preferred_username)}!</h6>
                <p className='WelcomePage-Paragraph'>Lets setup your information secuirty program. It will take less than 5 minutes!</p>
                <Link to="/Welcome/Onboarding"><button className='WelcomePage-Logi-button'>Lets get started!</button></Link>
                <Link to="/Dashboard" style={{textDecoration:"none"}} className='WelcomePage-Skip-button'>Skip for Now</Link>
            </div>
            <div className='DownParagraphDescription'>
                <h6 className='Down-Discription'>Platform Guidance & Activity</h6>
                <p className='Down-Discription-paragraph'>We are working hard to make the paltfrom more useful to you. We use your activity to :</p>
                <div>
                <p className='Down-Discription-List'>1. Provide contextual help & guidance</p>
                <p className='Down-Discription-List'>2. Ensure that our services are working as intended</p>
                <p className='Down-Discription-List'>3. Make product improvements</p>
                </div>
                <p className='Down-Discription-SubParagraph'>Your data remains anonymous. But you can turn these settings off anytime from your profile settings.
                          View Audyt privacy policy<Link to=""> <span className='Private-Policy'>Here</span></Link></p>
            </div>
            </div>
            <div>
                <img src={WelcomepageDesign} alt="Welcome page Design" className='WelcomePage-Side-Design'/>
            </div>
        </div>
    </div>
  )
}

export default Welcome